module.exports = __webpack_public_path__ + "img/chromecast.bc7c377a.svg";